module.exports = __webpack_public_path__ + "images/Jeff_Emmett.jpg?v=98e6a837ba4281d3e406f5f01a36fd84";